// extracted by mini-css-extract-plugin
export default {"priority-box":"Priority_priority-box__YQ6GP","priority-box-important":"Priority_priority-box-important__H+g+b","priority-box-urgent":"Priority_priority-box-urgent__qY9AJ"};